module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAOVBMVEUAAAD/MDD/MDD/Ly/+MDAICLYJCbcJCbYHB7wHB7X+MDAJCbb///+mpuSPj91ERMc3N8MiIr1KSsmn/DO5AAAACnRSTlMA8a4m7vGu7iYmp4ag8wAAAI5JREFUSMft0ksOwjAMRdEXOy0Q59v9L5YKkIrER34DBkg5g458VbcJJpfLuthb6UUQBc4nM2ewi4rVmCAJFi4IsMO4Pb4H6Tloxaw0Iui51ty9wWh9y7utt+F7Q8kPxbtSvc9X4wN2Jf6jud/6o4Pjr8bhD4P00QxmQEHg5gOECwQamfmogEpw7yOKyeMKSZdFg47Me1wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag/zh-TW@2x.png
// module id = z4Zv
// module chunks = 0